document.addEventListener('DOMContentLoaded', function () {

  setTimeout(function() {
    var whySwiper = new Swiper('.whySwiper', {

      slidesPerView: 3,
      spaceBetween: 24,
      navigation: {
        nextEl: '.swiper-button-next.swiper-pagination-featured-next',
        prevEl: '.swiper-button-prev.swiper-pagination-featured-prev',
      },
      breakpoints: {
        0: { slidesPerView: 1,
           autoHeight: true
         },
        767: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }, 100);
});